<template>
	<v-card color="rgba(255, 255, 255, 0.92)" class="text-xs-center my-4 pa-3">
		<v-card-text>
			<img v-wh="64" src="/img/aska-logo-small.png">

			<h1>All Star Kids Academy</h1>

			<v-divider class="w-50 my-3 mx-auto" />

			<a v-for="item in socialMedias" v-external :key="item.href" :href="item.href">
				<app-img v-wh="32" class="mx-3 mb-1" :data-src="item.img" />
			</a>

			<p>
				We are a <b>full service, state licensed</b> provider of infant and childcare,
				conveniently located on the Ringwood / Wanaque border.
			</p>
			<p>
				Any child can be a Star. Contact us today to schedule your tour!
			</p>

			<app-contact-btns color="#000" />

			<app-schedule-tour />
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	components: {
		AppScheduleTour: () => import('@/components/schedule-tour/Dialog.vue'),
	},

	data() {
		return {
			socialMedias: [
				{
					img: '/img/logo-facebook.png',
					href: 'https://www.facebook.com/allstarkidsacademy/',
				},
				{
					img: '/img/logo-instagram.png',
					href: 'https://www.instagram.com/allstarkidsacademy/',
				},
			],
		}
	},
}
</script>
